import { clearSession } from "../api/client";

export const getApiErrorMessage = (error) => error?.message || "Something went wrong.";

export const isUnauthorizedError = (error) => error?.status === 401;

export const handleApiError = (error, navigate) => {
  if (!isUnauthorizedError(error)) return false;

  clearSession();

  if (navigate) {
    navigate("/login", { replace: true });
  } else {
    window.location.replace("/login");
  }

  return true;
};

export const resolveApiError = (error, setError, navigate) => {
  if (handleApiError(error, navigate)) return;
  setError(getApiErrorMessage(error));
};
